import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { IAccountAdminService } from './../services/accounts-service';
let template = require('./accounts.html');

class AccountsComponent extends ComponentRegistration {

    constructor() {
        super('accounts', {
            controller: AccountsController,
            templateUrl: template,
            controllerAs: 'accounts',
            bindings: {

            },
            $routeConfig: [
                { path: '/', component: 'accountsGrid', name: 'AccountsGrid', useAsDefault: true },
                { path: '/:id', component: 'accountDetail', name:"AccountDetail" },
            ]
        });
    }
}

interface IAccountsController {
    activate(): void;
}

class AccountsController implements IAccountsController {
    private static $inject: Array<string> = ['$mdToast', 'AccountAdmin'];
    private data: Array<Object> = [];
    private show: boolean;
    private selectedAccount: any;

    constructor(private $mdToast: ng.material.IToastService,
        private AccountAdmin: IAccountAdminService) {
        console.log('AccountsController loading');
        this.activate();
    }

    public activate(): void {
        console.log('AccountsController loaded');
        this.show = true;
    }

    public accountSeletected(account): any {
        if (account) {
            this.selectedAccount = account;
            this.show = !this.show;
        }
        else {
            console.log('No account selected');
        }
    }
}

let accntComponent = new AccountsComponent();
export default accntComponent;
export { accntComponent as AccountsComponent, IAccountsController, AccountsController }



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/account/accounts.ts